import { get, patch, post } from 'lib/request'

export const validateConfirmationRequest = async ({
  id,
  hash,
}: {
  id: string
  hash: string
}) => {
  return await get('api/auth/confirmations/:id', {
    params: { id },
    query: new URLSearchParams({ hash }),
  })
}

// includes link validation
export const confirmRegistrationEmail = async ({
  id,
  hash,
}: {
  id: string
  hash: string
}) => {
  return await patch('api/auth/confirmations/:id/registration', {
    params: { id },
    query: new URLSearchParams({ hash }),
  })
}

export const resendConfirmationEmailWithRequestId = async ({
  id,
}: {
  id: string
}) => {
  return await post('api/auth/confirmations/:id/registration', {
    params: { id },
  })
}

export const resendConfirmationEmail = async () => {
  return await post('api/auth/confirmations/resend', {})
}

export const sendPasswordResetEmail = async ({ email }: { email: string }) => {
  return await post('api/auth/password', {
    query: new URLSearchParams({ email }),
  })
}

export const confirmPasswordReset = async ({
  id,
  hash,
  password,
}: {
  id: string
  hash: string
  password: string
}) => {
  return await patch('api/auth/confirmations/:id/password', {
    params: { id },
    query: new URLSearchParams({ hash }),
    body: {
      password,
    },
  })
}

export const acceptInvitation = async ({
  id,
  hash,
  password,
}: {
  id: string
  hash: string
  password: string
}) => {
  return await patch('api/auth/confirmations/:id/invitation', {
    params: { id },
    query: new URLSearchParams({ hash }),
    body: {
      password,
    },
  })
}

export const resendInvitatonEmail = async ({ id }: { id: string }) => {
  return await post('api/auth/confirmations/:id/invitation', {
    params: { id },
  })
}

export const confirmEmailChange = async ({
  id,
  hash,
}: {
  id: string
  hash: string
}) => {
  return await patch('api/auth/confirmations/:id/email', {
    params: { id },
    query: new URLSearchParams({ hash }),
  })
}

export const resendEmailChange = async ({ id }: { id: string }) => {
  return await post('api/auth/confirmations/:id/email', {
    params: { id },
  })
}
